import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as fragments from '../../../../../../dev/actions/gql/fragments'

export const DOC = gql`
  ${fragments.executionResult.DOC}
  mutation ExecuteMosaicAction(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $appPageId: ID!
    $actionIdentifier: FlexibleIdentifierInput!
    $variableOverrides: [VariableValueInput!]
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            mosaicPageRendering(appPageId: $appPageId) {
              executeAction(
                identifier: $actionIdentifier
                variableOverrides: $variableOverrides
              ) {
                ...FragmentMosaicActionExecutionResult
              }
            }
          }
        }
      }
    }
  }
`
const TRANSFORMER = graphql.transformers.OUT.validate(
  graphql.transformers.OUT.select<
    graphql.schema.ExecuteMosaicActionMutation,
    ents.core.mosaic.Action.ExecutionResult | undefined,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'mosaicPageRendering',
            graphql.transformers.OUT.select(
              'executeAction',
              fragments.executionResult.TRANSFORMER,
            ),
          ),
        ),
      ),
    ),
  ),
  TypeAsserter.assertIsNotNullish,
)

export const execute = graphql.createExecutor<
  graphql.schema.ExecuteMosaicActionMutation,
  ents.core.mosaic.Action.ExecutionResult,
  graphql.schema.ExecuteMosaicActionMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
